import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {initPlugins} from '@/utils/plugins'
import VueI18n from 'vue-i18n'
import locales from './locales'
import moment from 'moment/moment'
import VueTippy, {TippyComponent} from "vue-tippy";

Vue.component("Tippy", TippyComponent);
Vue.use(VueTippy, {
  theme: 'light'
});

const VueScrollTo = require('vue-scrollto')
Vue.config.productionTip = false
Vue.router = router

initPlugins(store)

Vue.config.errorHandler = function (err, vm, info) {
  console.error(err, vm, info)
}
Vue.config.warnHandler = function (msg, vm, trace) {
  console.warn(msg, vm, trace)
}

Vue.use(VueScrollTo)

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  silentTranslationWarn: true,
  messages: locales,
})

moment.locale(i18n.locale)

Vue.prototype.$localized = (obj = {}, fallback) => {
  if(Object.keys(obj).find(item => item === i18n.locale)) {
    return obj[i18n.locale]
  } else {
    return fallback ? fallback : Object.values(obj)[0]
  }
}

window.app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  methods: {
    sendSignal(...attrs) {
      this.$children[0].sendSignal(...attrs)
    },
  },
}).$mount('#app')
